// 获取所有卡片元素
document.addEventListener('DOMContentLoaded', function() {
    function getCardElements() {
      return document.querySelectorAll('.FadeAnimation');
    }
    
    // 节流函数，优化滚动性能
    function throttle(fn, delay = 200) {
      let timer = null;
      return function(...args) {
        if (!timer) {
          timer = setTimeout(() => {
            fn.apply(this, args);
            timer = null;
          }, delay);
        }
      };
    }

    // 检测卡片是否进入视口
    function checkCards() {
      const cards = getCardElements();
      cards.forEach((card, index) => {
        // 获取卡片的位置信息
        const rect = card.getBoundingClientRect();
        // 当卡片顶部进入视口底部 100px 时触发动画
        const isInViewport = rect.top < window.innerHeight - 100;
        
        if (isInViewport && !card.classList.contains('show')) {
          // 为每个卡片添加递增的延迟，实现渐进效果
          setTimeout(() => {
            card.classList.add('show');
          }, index * 150); // 每个卡片延迟 150ms，可根据需求调整
        }
      });
    }

    // 初始检查（处理首屏可见的卡片）
    checkCards();

    // 监听滚动事件（使用节流优化性能）
    window.addEventListener('scroll', throttle(checkCards));

    // 监听窗口大小变化，重新检查
    window.addEventListener('resize', throttle(checkCards));
});